export default "__VITE_ASSET__6vxGdH$O__"